import React, { useEffect, useState } from 'react';
import MultiCarousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Classes from './index.module.css';
import useTestimonials from '../Utils/useTestimonials';

const ReviewCarousel = () => {
    const [reviews, setReviews] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [infiniteStart, setInfiniteStart] = useState(1);

  const fetchReviews = async (page) => {
    setIsLoading(true);
    try {
      const response = await axios.post('https://exj3cjwpp3.execute-api.us-west-1.amazonaws.com/prod/Swmc-Social-Survey', {
        pageNumber: page
      });

      if (response.status === 200) {
        const newTestimonials = response.data;
        if (Array.isArray(newTestimonials)) {
          const transformedReviews = newTestimonials.map((ele) => {
            const date = new Date(ele.survey_completed_on);
            date.setDate(date.getDate() - 1); // Subtract one day from the date
            const monthNames = [
              "January", "February", "March", "April", "May", "June",
              "July", "August", "September", "October", "November", "December"
            ];
            const formattedDate = `on ${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
            const lastName = `${ele.customer_last_name.charAt(0)}.`;
            const firstName = ele.customer_first_name;

            return {
              id: ele.id,
              text: ele.review,
              rating: ele.rating,
              date: formattedDate,
              author: `${lastName}, ${formattedDate}`,
              name: ` ${firstName} ${lastName}`,
              showFullReview: false // Add a property to track if full review is visible or not
            };
          });

          setReviews([...reviews, ...transformedReviews]);

          if (transformedReviews.length >= 8) {
            setPageNumber(pageNumber + 1);
          }
        }
      } else {
        throw new Error('Request failed');
      }
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  };

  const getNewTestimonials = (page) => {
    fetchReviews(page);
  };

  useEffect(() => {
    getNewTestimonials(infiniteStart);
  }, [infiniteStart]);

  const handleSlideChange = () => {
    setTimeout(() => {
      if (infiniteStart < 500) {
        const nextPage = pageNumber + 1;
        setPageNumber(nextPage);
        setInfiniteStart(infiniteStart + 1);
        getNewTestimonials(nextPage);
      }
    }, 500);
  };

  const toggleFullReview = (reviewId) => {
    setReviews((prevReviews) =>
      prevReviews.map((review) => {
        if (review.id === reviewId) {
          return {
            ...review,
            showFullReview: !review.showFullReview
          };
        }
        return review;
      })
    );
  };

    const responsiveConfig = {
        desktop: {
            breakpoint: { max: 3000, min: 1200 },
            items: 3,
            slidesToSlide: 1,
        },
        largetablet: {
            breakpoint: { max: 1100, min: 992 },
            items: 2,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: { max: 991, min: 630 },
            items: 1,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: { max: 630, min: 0 },
            items: 1,
            slidesToSlide: 1,
        },
    };

    // Define the alternating color combinations
    const colorCombinations = ['#FF5C00', '#72369D', '#30A4F8'];

    return (
        <div>
            <Container>
                <h2 className={Classes.testimonial_heading}>Latest Testimonials</h2>
                <div className={Classes.carouselContainer}>
                    <MultiCarousel
                        responsive={responsiveConfig}
                        swipeable
                        draggable
                        arrows={false}
                        customTransition="transform 500ms ease-in-out"
                        className={Classes.testimonial_multicarousel}
                        afterChange={handleSlideChange}
                    >
                        {reviews.map((review, index) => {
                            // Determine the color for the current card
                            const color = colorCombinations[index % colorCombinations.length];
                            
                            return (
                                <div key={review.id}>
                                    <Container className={Classes.testimonial_card_container}>
                                        <Card className={Classes.card_Style} id={Classes.review_item}>
                                            <Row>
                                                <Col md={12}>
                                                    <div className={Classes.horizontal_author_details}>
                                                        <Row className={Classes.testimonials_rating}>
                                                            <Col md={6} lg={5} sm={7} xs={5}>
                                                                <fieldset
                                                                    className={Classes.ratingcolor}
                                                                    style={{ color: color }}
                                                                    disabled
                                                                >
                                                                    {[...Array(5)].map((_, i) => (
                                                                        <span
                                                                            key={i}
                                                                            className={`fa fa-star ${i < review.rating ? 'filled' : ''}`}
                                                                        >
                                                                            ★
                                                                        </span>
                                                                    ))}
                                                                </fieldset>
                                                            </Col>
                                                            <Col md={6} lg={7} sm={5} xs={7}>
                                                                <p
                                                                    className={Classes.datetext}
                                                                    style={{ color: color }}
                                                                >
                                                                    {review.date}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <Row>
                                                        <p className={Classes.testimonial_description}>
                                                            {review.showFullReview || review.text.length <= 165
                                                                ? review.text
                                                                : `${review.text.slice(0, 110)}...`}
                                                            {review.text.length > 110 && (
                                                                <span
                                                                    className={Classes.seeMoreLink}
                                                                    onClick={() => toggleFullReview(review.id)}
                                                                    style={{ color: color }}
                                                                >
                                                                    {' '}{review.showFullReview ? 'See Less' : 'See More'}
                                                                </span>
                                                            )}
                                                        </p>
                                                    </Row>
                                                    <Row>
                                                        <h6
                                                            className={Classes.name}
                                                            style={{ color: color }}
                                                        >
                                                            {review.name}
                                                        </h6>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Container>
                                </div>
                            );
                        })}
                    </MultiCarousel>
                    {isLoading && <p className={Classes.loadingText}>Loading...</p>}
                </div>
            </Container>
        </div>
    );
};

export default ReviewCarousel;